import { Logger } from '../../logger/logger';
import { HttpClient } from '../http/http-client/http-client';
import { HttpResponse } from '../http/http-response/http-response';
import { HttpRequestInit } from '../http/http-request/http-request';
import { HttpUtilService } from "../http/http-util-service";
import { CXoneAuthBase } from './cxone-auth-base';
import {AuthToken, AuthWithTokenReq} from '@nice-ccf/common-sdk';

/**
 * Class to generate new token using existing access token for token Exchange flow.
 */
export class CXoneAuthByToken extends CXoneAuthBase{

  logger: Logger = new Logger('lib.SDK', 'lib.CXoneAuthByToken');
  protected utilService: HttpUtilService = new HttpUtilService();
  private static singleton: CXoneAuthByToken;

   /**
   * Method to create singleton object of the class
   * ```
   * @example
   * const authObject = CXoneAuthByToken.instance();
   * ```
   */
    public static get instance(): CXoneAuthByToken {
      if (!CXoneAuthByToken.singleton) {
        CXoneAuthByToken.singleton = new CXoneAuthByToken();
        CXoneAuthBase.cxoneAuth = CXoneAuthByToken.singleton;
      }
      return CXoneAuthByToken.singleton;
    }
    

  /**
   * method to generate new token using existing token
   * 
   * @param cxoneHost - host url
   * @param accessToken  - existing token
   * @returns - return the access token
   * @example
   * 
   * ```
   * authenticate('http:testhost.com', 'eyJ0eXAiOiJKV1Qi...');
   * ```
   */
  authenticate({cxoneHost, accessToken} : AuthWithTokenReq): Promise<AuthToken> {
    return new Promise<AuthToken>((resolve, reject) => {
      this.getOpenIDConfiguration(cxoneHost).then(
        (response) => {
          const reqInit: HttpRequestInit = {
            headers: this.utilService.initHeader('', 'application/json').headers,
            body:
              'grant_type=urn:ietf:params:oauth:grant-type:token-exchange&scope=openid&' +
              'access_token=' + accessToken
          };
          HttpClient.post(response.tokenEndpoint, reqInit).then((resp: HttpResponse) => {
            if (resp.status === 200) {
              const cxOneAuthToken = this.parseAndSaveAuthToken(resp);
              this.logger.info('authenticate', 'Token generated successfully');
              resolve(cxOneAuthToken);
            }
          }, (err: HttpResponse) => {
            this.logger.error('authenticate', err.data.error_description);
            reject(err.data.error_description);
          });
        });
    });
  }

 

}
